/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Converter_TitleInputs */

const en_ui_labs_converter_title = /** @type {(inputs: Ui_Labs_Converter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace Calculator`)
};

const de_ui_labs_converter_title = /** @type {(inputs: Ui_Labs_Converter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace-Rechner`)
};

/**
* | output |
* | --- |
* | "Pace Calculator" |
*
* @param {Ui_Labs_Converter_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_converter_title = /** @type {((inputs?: Ui_Labs_Converter_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Converter_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_converter_title(inputs)
	return de_ui_labs_converter_title(inputs)
});